<template lang="pug">
v-layout(column key="buchen" v-if="hasdata")

  v-flex(xs12 text-center).mt-2
    h1.display-3.aiwsibg Termin buchen

  v-flex.mt-4
    v-card.elevation-1
      v-card-title {{$store.state.termintypes[$store.state.termtype].name}}
      v-card-subtitle.text--secondary am {{formattedDate}}, {{$store.state.daytimes_short[$store.state.daytime]}}
      v-card-text {{$store.state.termintypes[$store.state.termtype].desc}}

  v-flex.pr-2.pl-2.mt-4
    v-form(v-model="form.valid")
      v-row
        v-col.pb-0
          v-select(:items="form.genders" label="Geschlecht" v-model="form.gender")
      v-row
        v-col
          v-text-field(:rules="form.nameRules" v-model="form.firstname" label="Vorname" autocapitalize="words")
        v-col
          v-text-field(:rules="form.nameRules" v-model="form.lastname" label="Nachname" autocapitalize="words")
      v-row
        v-col
          v-text-field(:rules="form.emailRules" v-model="form.email" label="Email" validate-on-blur)
        v-col
          v-text-field(:rules="form.telRules" v-model="form.tel" label="Telefon")
      v-row
        v-col
          v-checkbox(required :rules="[v => !!v || 'Du musst zustimmen um fortzufahren!']" color="primary" v-model="form.datenschutz")
            template(v-slot:label)
              span Mit dem Abschluss der Buchung stimmen Sie der Verarbeitung Ihrer Daten gemäß der&ensp;
                router-link(to="/datenschutz" @click.native="datenschutzsave") Datenschutzbestimmungen
                |  zu
      v-row
        v-col.shrink
          v-btn(@click="$router.replace('/termin')" text) zurück
        v-col
          v-btn(@click="next" :outlined="!form.valid" :disabled="!form.valid" block :color="form.valid ? 'primary' : ''") Weiter
</template>

<script>
export default {
  data: () => ({
    hasdata: false,
    form: {
      datenschutz: false,
      valid: false,
      gender: undefined,
      firstname: "",
      lastname: "",
      email: "",
      tel: "",
      genders: ["Herr", "Frau", "Kampf-Hubschrauber", "Sonstige"],
      nameRules: [
        v => !!v || "Bitte Namen eintragen",
        v =>
          !/^(vor|nach)?name$/i.test(v) ||
          "Haha sehr clever. Gib bitte deinen eigenen Namen ein.",
      ],
      emailRules: [
        v => !!v || "Bitte Email eintragen",
        v => /.+@.+\..+/.test(v) || "Bitte gültige Email eintragen",
      ],
      telRules: [
        v => !!Number(v.replace(/ /g, "")) || "Bitte Nummer eintragen",
        v => v.length > 5 || "Bisschen kurz oder?",
      ],
    },
  }),
  mounted() {
    window.buchen = this
    if (this.$store.state.pendingAuth && this.$store.state.retries < 1) {
      this.$router.replace("/verifizieren")
    }

    const { daytime, date, termtype } = this.$store.state

    if (isNaN(daytime) || !date || isNaN(termtype))
      return this.$router.replace("/termin")
    else this.hasdata = true

    const { gender, firstname, lastname, email, tel } = this.$store.state

    if (gender) this.form.gender = gender
    if (firstname) this.form.firstname = firstname
    if (lastname) this.form.lastname = lastname
    if (email) this.form.email = email
    if (tel) this.form.tel = tel
  },
  methods: {
    datenschutzsave() {
      const { gender, firstname, lastname, email, tel } = this.form
      this.$store.commit("setData", { gender, firstname, lastname, email, tel })
    },
    next() {
      const { gender, firstname, lastname, email, tel } = this.form
      this.$store.commit("setData", { gender, firstname, lastname, email, tel })
      if (this.$store.state.retries > 1) this.$router.replace("/verifizieren")
      else this.$router.replace("/verifizieren")
    },
  },
  computed: {
    formattedDate() {
      if (!this.$store.state.date) return null

      const [year, month, day] = this.$store.state.date.split("-")
      return `${day}. ${this.$store.state.months[Number(month) - 1]} ${year}`
    },
  },
}
</script>

<style lang="stylus">
@media only screen and (max-width: 360px)
  .v-application h1.aiwsibg.display-3
    font-size: 3rem !important
</style>